import React, { useContext } from 'react'
import { EasybakeContext } from '../EasybakeProvider'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import analytics from '../../config/analytics'

import Heading from '@react/react-spectrum/Heading'
import Button from '@react/react-spectrum/Button'
import Well from '@react/react-spectrum/Well'
import { goToUrlTarget } from '../../lib/easybake'
import Ps from '../../asset/img/ps.svg'
import Link from '../Nav/Link'

export default function TilePsApiReference () {
    const { page } = useContext(EasybakeContext)

    function goToDoc() {
        analytics.sendEventName('click', `${page}:createproject:sdk`)
        goToUrlTarget(__('console_credinfo_api_reference_link'), '_blank')
    }

    return (
        <div className="adobe-easybake-flex-row-contents">
        <Well className="adobe-easybake-well-card">
            <div className="adobe-easybake-build-title">
                <div className="adobe-easybake-credinfo-logo-create"><img src={Ps} alt="" className="sub-nav-icon" /></div>
                <Heading variant="subtitle1">{__('console_credinfo_api_ref_title')}</Heading>
            </div>
            <div className="adobe-easybake-well-body">{__('console_credinfo_api_ref_desc')}</div>
            <hr className="adobe-easybake-hr"/>
            <div className="adobe-easybake-well-card-button">
                {/* <Link className="adobe-easybake-credinfo-link" referrer={`console:${page}:buildproject:lambda`} label={__('console_credinfo_view_doc')} url={__('console_credinfo_api_doc_link')} noBreak={true} /> */}
                <Button variant="primary" onClick={ e => { goToDoc(e) }}>{__('console_credinfo_view_api_ref_btn')}</Button>
            </div>
        </Well>
    </div>
    )
}
